import createTree from '../utils/createTree';
import getJWT from '../utils/getJWT';

export default function CheckPrivileges({ privileges, children, fallback }) {
  
  if (process.env.NODE_ENV === 'test') {
    return children;
  }

  const decoded = getJWT();

  // default to true if no privileges were specified
  let allowed = !privileges;

  if (privileges && decoded && decoded.privileges) {
    allowed = privileges.every(p => decoded.privileges.includes(p));
  }

  if (!allowed) {
    // render fallback if defined
    return fallback
      ? Array.isArray(fallback)
        ? fallback.map(createTree)
        : createTree(fallback)
      : null;
  }

  return children;
}
